import { ApiError } from '@glomopay/utils';

import type { TApiFailureAttributes } from '../types/analytics-events.types';

// A contract that drifted and a connection that dropped look the same in a status code, but need
// different people paged.
export const describeApiFailure = (error: unknown): TApiFailureAttributes => {
  if (!(error instanceof ApiError)) return { statusCode: 0, failureKind: 'unknown' };

  // ApiClient reports a failed Zod parse as an ApiError with a synthetic 500, indistinguishable from
  // a real server 500 by status alone; only a failed parse carries validationIssues.
  if (error.validationIssues) return { statusCode: error.statusCode ?? 0, failureKind: 'schema_validation' };

  // No status means the request never got a response: offline, DNS, timeout, CORS, abort.
  if (!error.statusCode) return { statusCode: 0, failureKind: 'network' };

  return { statusCode: error.statusCode, failureKind: 'http' };
};
